import { STATE_CODES } from '@constants/giCar'

export const randomPlate = (): string => {
  const state = STATE_CODES[Math.floor(Math.random() * STATE_CODES.length)]
  const district = String(Math.floor(Math.random() * 99) + 1).padStart(2, '0')
  const series =
    String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
    String.fromCharCode(65 + Math.floor(Math.random() * 26))
  const number = String(Math.floor(Math.random() * 9000) + 1000)
  return `${state}${district}${series}${number}`
}
